// src/components/GoogleMaps.jsx
import React, { memo } from 'react';
import PlaceHolder from '../img/icon/placeholder.png';
import {
  GoogleMap,
  Marker,
  useJsApiLoader
} from '@react-google-maps/api';

const DEFAULT_CONTAINER_STYLE = {
  width: '100%',
  height: '100%'
};

// URL di default per il marker selezionato
const HIGHLIGHT_ICON = PlaceHolder;

const GoogleMaps = ({
  center,
  zoom,
  markers,
  selectedMarker,           
  onMarkerClick, 
  mapContainerStyle = DEFAULT_CONTAINER_STYLE
}) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyCHeo68RxjEGD5OePZbxw73Czq4nUFJu3E'
  });

  if (loadError) {
    return <div>Errore nel caricamento della mappa</div>;
  }
  if (!isLoaded) {
    return <div>Loading map…</div>;
  }

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      center={center}
      zoom={zoom}
    >
      {markers &&
        markers.map((marker, i) => {
          const isSelected =
            selectedMarker &&
            marker.codice === selectedMarker.codice;

          return (
            <Marker
              key={i}
              position={marker.position}
              // se è selezionato, cambio l'icona e faccio rimbalzare
               icon={
                    isSelected
                      ? {
                          url: HIGHLIGHT_ICON,
                          scaledSize: new window.google.maps.Size(42, 40)
                        }
                      : undefined
                  }
              onClick={() => {
               onMarkerClick(marker, i);
              }}
          
              // animation={
              //   isSelected
              //     ? window.google.maps.Animation.BOUNCE
              //     : undefined
              // }
            />
          );
        })}
    </GoogleMap>
  );
};

export default memo(GoogleMaps);
